export default {
  // 跨链详情弹框
  dialog: {
    title: "查看详情",
    sourceSection: {
      hashLabel: "来源交易哈希",
      timeLabel: "发起时间:",
    },
    targetSection: {
      hashLabel: "目标交易哈希",
      timeLabel: "接收时间:",
    },
    sender: "发送方",
    receiver: "接收方",
    flowText: "跨链换币",
    copySuccess: "复制成功",
  },

  // 跨链列表
  list: {
    sort: {
      sendAmount: "发送数量",
      sendTime: "发送时间",
      receiveAmount: "接收数量",
      receiveTime: "接收时间",
      desc: "倒序",
      asc: "正序",
    },
    hash: {
      source: "来源哈希：",
      target: "目标哈希：",
    },
    grid: {
      sender: "发送方",
      receiver: "接收方",
      sendAmount: "发送数量",
      sendTime: "发送时间",
      receiveAmount: "接收数量",
      receiveTime: "接收时间",
    },
    buttons: {
      trace: "跨链追踪",
      detail: "详情",
    },
    messages: {
      traceSuccess: "跨链追踪成功",
      traceFailed: "跨链追踪失败，请稍后重试",
      chainNotSupportedWithName:
        "当前跨链追踪至{chainName}链，当前画布暂不支持上图分析，是否去跨链浏览器查看数据？",
      chainNotSupportedGeneric:
        "当前跨链追踪至的链暂不支持上图分析，是否去跨链浏览器查看数据？",
      tip: "提示",
      cancel: "取消",
      viewInBrowser: "浏览器查看",
    },
    download: {
      filename: "跨链交易详情.xlsx",
    },
  },
};
